import { render, staticRenderFns } from "./QuestionBuilder.vue?vue&type=template&id=88dc3c4e&scoped=true&"
import script from "./QuestionBuilder.vue?vue&type=script&lang=js&"
export * from "./QuestionBuilder.vue?vue&type=script&lang=js&"
import style0 from "./QuestionBuilder.vue?vue&type=style&index=0&id=88dc3c4e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88dc3c4e",
  null
  
)

export default component.exports